import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ApiConfiguration } from '../api-configuration';
import { BaseService } from '../base-service';
import { ShareSmsPayload } from '../models/share-manual.models';

interface ApiEnvelope<T> {
  status: string;
  message?: string;
  data: T;
}

@Injectable({ providedIn: 'root' })
export class ShareManualService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  sendLinkViaSms(payload: ShareSmsPayload): Observable<string> {
    return this.http
      .post<ApiEnvelope<unknown>>(`${this.rootUrl}/api/v1/share/sms`, payload)
      .pipe(map((response) => String(response?.message ?? '').trim()));
  }
}
